module.exports = __webpack_public_path__ + "indicators.77f590127a879513837c5a1faea513bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/indicators.svg
// module id = 327
// module chunks = 0